export default class CustomSelect {
    constructor(element) {
        this.element = element;
        this.element_options = this.getSelectOptions(this.element);
        this.isOpen = false;
        
        // Bind methods to this to avoid context issues
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        
        this.init();
        this.bindEvents();
    }

    bindEvents() {
        $(this.element).off('mousedown').on('mousedown', e => {
            this.toggleSelect(e);
        });
    }

    reBindEvents() {
        const dropdown = $(this.element).next('.form-custom-select-dropdown');
        
        // First remove any previous event listeners
        dropdown.find('.form-custom-select-dropdown-item').off('click');
        
        // Then add the click event with the properly bound handler
        dropdown.find('.form-custom-select-dropdown-item').on('click', this.onItemClick);
    }

    init() {
        let autocompleteContent = '';
        this.element_options.forEach(option => {
            if (!option.disabled) {
                autocompleteContent += this.buildElement(option.value, option.label);
            }
        });
        $(this.element).after(`<div class="form-custom-select-dropdown">${autocompleteContent}</div>`);
        this.reBindEvents();
    }

    getSelectOptions( select ) {
        let options = [];
        $(select).find("option").each(function() {
            options.push({
                value: $(this).val(),
                label: $(this).html(),
                disabled: $(this).is(':disabled')
            });
        });
        return options;
    }

    onDestroy() {
    }

    buildElement(value, label) {
        return `<div class="form-custom-select-dropdown-item" data-value="${value}">${label}</div>`
    }

    toggleSelect(e) {
        if (window.innerWidth > 768) {
            e.preventDefault();
            e.stopPropagation();
            
            if (!this.isOpen) {
                this.openSelect(e);
            } else {
                this.closeSelect();
            }
        }
    }

    openSelect(e) {
        if (e) e.stopPropagation();
        this.element.classList.add('show');
        this.isOpen = true;
        
        // Add a single document click listener
        $(document).on('click', this.handleDocumentClick);
    }
    
    handleDocumentClick(e) {
        // If the click is not on the select element or its children, close the select
        if (!$(e.target).closest(this.element).length && 
            !$(e.target).closest('.form-custom-select-dropdown').length) {
            this.closeSelect();
        }
    }
    
    closeSelect() {
        if (!this.isOpen) return;
        
        this.element.classList.remove('show');
        this.isOpen = false;
        
        // Remove the document click listener
        $(document).off('click', this.handleDocumentClick);
    }
    
    onItemClick(e) {
        e.preventDefault();
        e.stopPropagation();
        
        let value = $(e.currentTarget).data('value');
        let select = $(this.element);
        
        select.val(value);
        select.trigger('change');
        this.closeSelect();
    }
}